import { TYPOGRAPHY } from "@tCentro/theme/design";
import { buttonBaseStyles } from "@tCentro/theme/mixins";
import { css, withTheme } from "styled-components";

const buttonType = {
    solid: "solid",
    outline: "outline",
    tertiary: "tertiary",
};

const baseProps = {
    hoverMode: "darken",
    activeMode: "darken",
    sizeVariant: "medium",
    typographyProps: {
        weight: TYPOGRAPHY.weight.mediumbold,
        size: TYPOGRAPHY.size.smaller,
        css: css`
        line-height: 16px;
        `,
    },
    shape: "rounded",
    css: buttonBaseStyles(buttonType.solid),
};

export default {
    primary: {
        ...baseProps,
        color: "secondary.main",
        buttonType: buttonType.solid,
        css: buttonBaseStyles(buttonType.solid),
    },
    secondary: {
        ...baseProps,
        color: "secondary.main",
        buttonType: buttonType.outline,
        css: buttonBaseStyles(buttonType.outline),
    },
    tertiary: {
        ...baseProps,
        color: "white",
        buttonType: buttonType.solid,
        css: buttonBaseStyles(buttonType.tertiary),
    },
    defaultProps: {
        css: buttonBaseStyles(buttonType.solid),
    },
};
